import { render, staticRenderFns } from "./paidTournament.vue?vue&type=template&id=6bc688e1&"
import script from "./paidTournament.vue?vue&type=script&lang=js&"
export * from "./paidTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports